export const debounce = <Args extends unknown[]>(
  func: (...args: Args) => void,
  waitMs: number,
) => {
  let timeout: ReturnType<typeof setTimeout>;

  const executedFunction = (...args: Args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), waitMs);
  };

  executedFunction.cancel = () => {
    clearTimeout(timeout);
  };

  return executedFunction;
};
